import { INotificationsResponse, INotificationsParams } from 'types'
import { baseApi } from './baseApi'



export const notificationsAPI = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    GET_notifications: builder.query<INotificationsResponse, INotificationsParams>({
      query: (params) => ({
        url: '/notifications/',
        params,
      }),
    }),
  }),
})

export const { useGET_notificationsQuery } = notificationsAPI
